import React from 'react';
import {
  ReferralsView,
  NotReferringView,
  PatientJourneyView,
  TreatingVolumeView,
} from './Views';
export { default as StrategyProfileView } from './StrategyProfileView';

export * from 'src/components/ProfileDrawer/components/StrategyProfileContent';
export * from './components/StrategyProfileHeader';
export * from './components/StrategyProfileMetrics';
export * from './components/StrategyProfileResults';
export * from './components/StrategyProfileList';
export * from './components/StrategyProfileMap';
export * from './components/StrategyErrorState';
export * from './components/StrategyLoadingState';
export * from './components/StrategyProfileMap/components/MapZoomControls';

// Define the strategy types once as a const assertion
export const STRATEGY_TYPES = [
  'REFERRALS',
  'NOT_REFERRING',
  'PATIENT_JOURNEY',
  'TREATING_VOLUME',
] as const;

export type StrategyType = typeof STRATEGY_TYPES[number];

export const STRATEGY_VIEWS: Record<
  StrategyType,
  React.FC<{ engageStrategyId: string }>
> = {
  REFERRALS: ReferralsView,
  NOT_REFERRING: NotReferringView,
  PATIENT_JOURNEY: PatientJourneyView,
  TREATING_VOLUME: TreatingVolumeView,
};

export const STRATEGY_COLORS: Record<StrategyType, string> = {
  REFERRALS: 'text-pink-600',
  NOT_REFERRING: 'text-pink-600',
  PATIENT_JOURNEY: 'text-pink-600',
  TREATING_VOLUME: 'text-pink-600',
};
